import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'core/components/label';
import { SelectableRow } from 'core/components/table/selectable-row';
import { SelectableCell } from 'core/components/table/selectable-cell';
import { awsDateToDateFormatter } from 'core/helpers/formatters';
import useStyles from './global-results.styles';

// Members carry a Cognito UserCreateDate, offers an updatedDateTime, and plenty of older
// documents carry neither. date-fns `format` throws on an invalid date, which would take the
// whole dropdown down, so an unusable value renders as an empty cell.
const formatDate = (dateValue) => {
  if (!dateValue) {
    return '';
  }
  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? '' : awsDateToDateFormatter(date);
};

const Row = ({ hit, onClick }) => {
  const classes = useStyles();
  // The leading cell names the kind of thing this row is; the rest is the record itself. Every
  // cell links to the same destination so the whole row is clickable.
  const dataCells = [
    hit.id,
    hit.fname,
    hit.lname,
    hit.address,
    hit.city,
    hit.state,
    hit.zip,
    formatDate(hit.dateValue)
  ];

  return (
    <SelectableRow className={classes.tableRow} hover id={hit.key} value={hit} onClick={onClick}>
      <SelectableCell to={hit.to}>
        <Label type="infoLabel">{hit.resultType}</Label>
      </SelectableCell>
      {dataCells.map((cell, index) => (
        <SelectableCell
          to={hit.to}
          key={`${hit.key}-${index}`}
          align={index === dataCells.length - 1 ? 'right' : 'inherit'}
        >
          {cell}
        </SelectableCell>
      ))}
    </SelectableRow>
  );
};

Row.propTypes = {
  hit: PropTypes.shape({
    key: PropTypes.string.isRequired,
    resultType: PropTypes.string.isRequired,
    id: PropTypes.string,
    fname: PropTypes.string,
    lname: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    dateValue: PropTypes.string,
    to: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func
};

Row.defaultProps = {
  onClick: null
};

export default Row;
